/**
 * 홈 트래킹 부트스트랩.
 *
 * 역할:
 *   - 섹션 DOM 순번 자동 산출 (templates/index.json 의 order 배열은 Liquid에 노출 안 되므로 DOM 순서 기반)
 *   - GBTrackEnrich 훅 정의: 발사 직전 props.index 자동 주입 (이미 있으면 덮어쓰지 않음)
 *
 * 제외 대상 (분석 무의미):
 *   - .piyonna-spacer-section
 *   - .content-section-section
 *   - .piyonna-page-config-section
 *   - offsetHeight === 0 (빈 섹션 / disabled)
 */
(function () {
  'use strict';

  var orderMapCache = null;

  function isVisibleAnalyticsSection(s) {
    if (!s) return false;
    if (s.classList.contains('piyonna-spacer-section')) return false;
    if (s.classList.contains('content-section-section')) return false;
    if (s.classList.contains('piyonna-page-config-section')) return false;
    if (s.offsetHeight === 0 && s.offsetWidth === 0) return false;
    return true;
  }

  function buildOrderMap() {
    var m = {};
    var idx = 0;
    var sections = document.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (!isVisibleAnalyticsSection(s)) continue;
      idx += 1;
      var raw = s.id || '';
      var id = raw.replace(/^shopify-section-/, '');
      if (id) m[id] = idx;
    }
    return m;
  }

  function ensureMap() {
    if (!orderMapCache) orderMapCache = buildOrderMap();
    return orderMapCache;
  }

  function init() {
    ensureMap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 발사 직전 props 보강.
  // - tracking_id 가 props에 있고 index가 비어있으면 섹션 DOM 순번을 index로 채움.
  // - props.index 가 이미 있으면 entity index 우선 — 덮어쓰지 않음.
  window.GBTrackEnrich = function (event, props, el) {
    if (!props) return;
    if (props.index != null) return;
    var key = props.tracking_id;
    if (!key) return;
    var map = ensureMap();
    if (map[key]) props.index = map[key];
  };
})();
